// extracted by mini-css-extract-plugin
module.exports = {"sortBy":"SortBy_sortBy__jhiNr"};